import React, { useContext, useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { Button, TextField, Typography } from '@mui/material';
import { convertErrors } from '../MeetupList/components/MeetupEditForm/MeetupEditForm';
import { AppContext } from '@/AppContext';
import ErrorBlock from '@/components/ErrorBlock/ErrorBlock';

const PREFIX = 'RequestForChangePassword';

const classes = {
  root: `${PREFIX}-root`,
  grid: `${PREFIX}-grid`,
  contentContainer: `${PREFIX}-contentContainer`,
  content: `${PREFIX}-content`,
  formContainer: `${PREFIX}-formContainer`,
  contentHeader: `${PREFIX}-contentHeader`,
  logoImage: `${PREFIX}-logoImage`,
  contentBody: `${PREFIX}-contentBody`,
  form: `${PREFIX}-form`,
  formInputsContainer: `${PREFIX}-formInputsContainer`,
  bottomText: `${PREFIX}-bottomText`,
  title: `${PREFIX}-title`,
  textField: `${PREFIX}-textField`,
  signUpButton: `${PREFIX}-signUpButton`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    height: '100%',
  },

  [`& .${classes.grid}`]: {
    height: '100%',
  },

  [`& .${classes.contentContainer}`]: {
    backgroundColor: 'white',
  },

  [`& .${classes.content}`]: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },

  [`& .${classes.formContainer}`]: {
    padding: '10px  45px',
    border: '1px solid #ffffff',
    borderBottomColor: '#DEDEDE',
    borderTopColor: '#DEDEDE',
    height: 'calc(100% - 85px)',
    paddingBottom: 30,
  },

  [`& .${classes.contentHeader}`]: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(5),
    paddingBototm: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },

  [`& .${classes.logoImage}`]: {
    marginLeft: theme.spacing(4),
  },

  [`& .${classes.contentBody}`]: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  [`& .${classes.form}`]: {
    backgroundColor: 'white',
    height: '320px',
    width: '640px',
    padding: '30px',
    borderRadius: '8px',
  },

  [`& .${classes.formInputsContainer}`]: {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },

  [`& .${classes.bottomText}`]: {
    marginTop: '20px',
    width: '100%',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#213955',
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '16px',
  },

  [`& .${classes.title}`]: {
    color: '#213955',
    textAlign: 'center',
    fontFamily: 'Roboto',
    fontSize: '22px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '28px',
    letterSpacing: '-0.06px',
    marginBottom: 20,
  },

  [`& .${classes.textField}`]: {
    marginTop: '20px',
  },

  [`& .${classes.signUpButton}`]: {
    marginTop: '24px',
  },
}));

export {};
const RequestForChangePassword = () => {
  const appContext = useContext(AppContext);

  const [formState, setFormState] = useState({
    values: {},
    touched: {},
    errors: {},
  });

  useEffect(() => {
    setFormState(formState => ({
      ...formState,
      errors: errors || {},
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formState.values]);
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    if (errors) {
      setFormState({
        ...formState,
        ...convertErrors(errors),
      });
    }
  }, [errors]);

  const handleRegister = event => {
    event.preventDefault();
    appContext.authApi
      .requestChangePassword(formState.values)
      .then(({ data }) => {
        appContext.history.push('/change-password-success');
      })
      .catch(error => {
        const data = error.response.data;
        setErrors(data.errors || [data]);
      });
  };

  const handleChange = event => {
    event.persist();

    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]: event.target.type === 'checkbox' ? event.target.checked : event.target.value,
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true,
      },
    }));
  };

  const hasError = field => {
    return !!(formState.touched[field] && formState.errors[field]);
  };

  return (
    <Root className={classes.root}>
      <div className={classes.content}>
        <div className={classes.contentBody}>
          <ErrorBlock message={formState.errors.token} />
          <form className={classes.form} onSubmit={handleRegister}>
            <Typography className={classes.title} variant='h2'>
              Восстановить пароль
            </Typography>
            <div className={classes.formContainer}>
              <TextField
                className={classes.textField}
                error={hasError('email')}
                fullWidth
                helperText={hasError('email') ? formState.errors.email : null}
                label='Адрес электронной почты'
                name='email'
                onChange={handleChange}
                type='text'
                value={formState.values.email || ''}
                variant='outlined'
                required={false}
                autoComplete={'off'}
              />
              <Button
                className={classes.signUpButton}
                color='primary'
                fullWidth
                size='large'
                type='submit'
                variant='contained'
              >
                Отправить письмо
              </Button>
            </div>
            <div className={classes.bottomText}>
              <p onClick={() => appContext.history.push('/sign-in')} style={{ cursor: 'pointer' }}>
                Вход администратора
              </p>
            </div>
          </form>
        </div>
      </div>
    </Root>
  );
};

// Legacy hook for backward compatibility
export const useStyles = () => classes;
export { Root as StyledRoot };

export default RequestForChangePassword;
